// There are significant animation performance differences between Chrome and Safari/Firefox. Browsers other than
// Safari and Firefox are assumed to have the same performance characteristics as Chrome as they are all based on Chromium.
let isSafariBrowser = false;
let isFirefoxBrowser = false;
if (typeof navigator !== 'undefined') {
  const ua = navigator.userAgent;
  // lots of browsers include "safari" in their UA name for historical reasons, we exclude those then look for "safari"
  isSafariBrowser = /^((?!chrome|chromium|crios|fxios).)*safari/i.test(ua);
  // Firefox is pretty easy to detect in comparison
  isFirefoxBrowser = /Firefox/.test(ua);
}

export const isSafari = isSafariBrowser;
export const isFirefox = isFirefoxBrowser;
